<template>
	<div class="GroupOverview">
		<!-- <daohang></daohang> -->
		<banner2 :bannerH="h1" :bannerP="P1" :bannerImg="Img1"></banner2>
		<!-- 关于企业 -->
		<div class="about-bg">
			<div class="com-title">
				<h3>企业简介
					<p>COMPANY PROFILE</p>
				</h3>
			</div>
			<div class="about" id="about">
				<div class="about-top">
					<div class="about-top-l">
						<span> 关于企业 </span>
						<p>
							江西正能智慧科技有限公司(以下简称公司) 成立于 2016 年10月28日，位于江西省南昌市赣江中大道 1218 号新地中心，注册资本 20001 万元人民币，实缴资本10001 万人民币。<br />
公司业务围绕电力设备信息化、数字化应用布局，致力于电力专用软硬件系统开发、电力购销、新能源投资运营、 电力设备检测/维保等综合能源服务。公司独立开发了能源综合管理、配电房数字化、 电缆/变压器/开关设备在线监测、 物联网开关等配用电领域软硬件系统，从40.5kV变电站设备、电缆到 0.4kV 终端配电箱，公司具备全栈电力设施在线监测、 数据存储、智能运维、 故障预警等产品开发能力。
						</p>
					</div>
					<div class="about-top-r">
						<div class="img-yinying"></div>
						<img
							src="https://img.js.design/assets/img/613eaa7ba9696d53260506a9.png"
							alt=""
						/>
					</div>
				</div>
				<!-- <div class="about-down">
					<div class="item">
						<span class="item-1">30</span>
						<span class="item-2">+</span>
						<span class="item-3">全国校区</span>
					</div>
					<div class="item2">
						<span class="item-1">10</span>
						<span class="item-2">+</span>
						<span class="item2-3">覆盖城市</span>
					</div>
					<div class="item3">
						<span class="item-1">7000</span>
						<span class="item-2">+</span>
						<span class="item3-3">优秀讲师</span>
					</div>
					<div class="item4">
						<span class="item-1">80</span>
						<span class="item-2">万</span>
						<span class="item4-3">服务学生</span>
					</div>
				</div> -->
			</div>
		</div>
		<!-- 企业文化 -->
		<div class="qywh" id="CultureInfo">
			<div class="com-title">
				<h3>企业文化
					<p>COMPANY CULUTURE</p>
				</h3>
			</div>
			<div class="culture-container fx fw jsb">
                
                <div class="culture-item">
                    <img src="../assets/about/wh_01.png" alt="">
                    <div class="txt">
                        <h4>企业使命</h4>
                        <p>Corporate mission</p>
                    </div>
                    <div class="hover-box fx fc jcc ac">
                        <h3>企业使命</h3>
                        <div class="culture-info">
                            <p>通过持续创新，为客户创造最大价值</p>
                        </div>
                    </div>
                </div>
                
                <div class="culture-item">
                    <img src="../assets/about/wh_02.png" alt="">
                    <div class="txt">
                        <h4>企业愿景</h4>
                        <p>Enterprise vision</p>
                    </div>
                    <div class="hover-box fx fc jcc ac">
                        <h3>企业愿景</h3>
                        <div class="culture-info">
                            <p>成为中国企业级市场中不可或缺的电力服务的领导者</p>
                        </div>
                    </div>
                </div>
                
                <div class="culture-item">
                    <img src="../assets/about/wh_03.png" alt="">
                    <div class="txt">
                        <h4>企业精神</h4>
                        <p>Enterprise spirit</p>
                    </div>
                    <div class="hover-box fx fc jcc ac">
                        <h3>企业精神</h3>
                        <div class="culture-info">
                            <p>诚信负责、成就客户、创新为要</p>
                        </div>
                    </div>
                </div>
                
                <div class="culture-item">
                    <img src="../assets/about/wh_04.png" alt="">
                    <div class="txt">
                        <h4>企业价值观</h4>
                        <p>Corporate values</p>
                    </div>
                    <div class="hover-box fx fc jcc ac">
                        <h3>企业价值观</h3>
                        <div class="culture-info">
                            <p>协同、敏捷、专业、奋斗.</p>
                        </div>
                    </div>
                </div>
                
                <div class="culture-item">
                    <img src="../assets/about/wh_05.png" alt="">
                    <div class="txt">
                        <h4>企业经营宗旨</h4>
                        <p>Business purpose</p>
                    </div>
                    <div class="hover-box fx fc jcc ac">
                        <h3>企业经营宗旨</h3>
                        <div class="culture-info">
                            <p>公司专业致力于电力购销、电力试验、 电力设备检测、 运维托管、 电力抢修、配电改造等商市场为目标，以客户为导向，以业内领先的应用技术为基础，通过为客户提供端到端的全方位解决方案，帮助客户提升核心竞争力。</p>
                        </div>
                    </div>
                </div>
                
            </div>
		</div>

		<!-- 发展历程 -->
		<div class="DevelopmentHistory" id="history">
			<div class="DevelopmentHistory_cont">
				<div class="com-title">
					<h3>荣誉资质
						<p>HONOR AND QUALIFICATION</p>
					</h3>
				</div>
				<div class="honor-tabs">
					<ul class="honor-ul fx ac jcc">
						<li class="honor-li" @click="cur=0" :class="{'honor-active':cur==0}">资质证书</li>
						<li class="honor-li" @click="cur=1" :class="{'honor-active':cur==1}">知识产权</li>
					</ul>
				</div>
				<div class="elegant-center">
					<div class="elegant-img" v-show="cur==0">
						<swiper ref="mySwiper" :options="swiperOptions2">
							<swiper-slide v-for='(item, index) in swiperList1' :key='index'>
								<img :src="item.src" alt="">
							</swiper-slide>
							<!-- <div class="swiper-pagination" slot="pagination"></div> -->
							<div class="swiper-button-prev" slot="button-prev"></div>
							<div class="swiper-button-next" slot="button-next"></div>
						</swiper>
					</div>
					<div class="elegant-img" v-show="cur==1">
						<swiper ref="mySwiper" :options="swiperOptions3">
							<swiper-slide v-for='(item, index) in swiperList2' :key='index'>
								<img :src="item.src" alt="">
							</swiper-slide>
							<!-- <div class="swiper-pagination" slot="pagination"></div> -->
							<div class="swiper-button-prev" slot="button-prev"></div>
							<div class="swiper-button-next" slot="button-next"></div>
						</swiper>
					</div>
				</div>
			</div>
		</div>

		<!-- 企业风采 -->
		<div class="elegant-view" id="m5">
            <div class="main-center w-body">
                <div class="com-title">
                    <h3>企业风采
                        <p>CORPORATE STYLE</p>
                    </h3>
                </div>
                <div class="elegant-img">
					<swiper ref="mySwiper" :options="swiperOptions1">
						<swiper-slide v-for='(item, index) in swiperList' :key='index'>
							<img :src="item.src" alt="">
						</swiper-slide>
						<div class="swiper-pagination" slot="pagination"></div>
						<!-- <div class="swiper-button-prev" slot="button-prev"></div>
						<div class="swiper-button-next" slot="button-next"></div> -->
					</swiper>
				</div>
            </div>
        </div>
		
		<!-- 底部 -->
	</div>
</template>

<script>
// import daohang from "../components/nav.vue";

import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import banner2 from "../components/banner.vue";
export default {
	name: "App",
	data() {
		return {
			h1: "关于我们",
			P1: "精益求精，服务至上",
			Img1: require("../assets/img/bannerjituan.png"),
			swiperList: [
                {
                    id: 1,
                    src: require('@/assets/about/fc_img.jpg')
                },{
                    id: 2,
                    src: require('@/assets/about/fc_img.jpg')
                },{
                    id: 3,
                    src: require('@/assets/about/fc_img.jpg')
                },{
                    id: 4,
                    src: require('@/assets/about/fc_img.jpg')
                },{
                    id: 5,
                    src: require('@/assets/about/fc_img.jpg')
                },{
                    id: 6,
                    src: require('@/assets/about/fc_img.jpg')
                },{
                    id: 7,
                    src: require('@/assets/about/fc_img.jpg')
                },{
                    id: 8,
                    src: require('@/assets/about/fc_img.jpg')
                },{
                    id: 9,
                    src: require('@/assets/about/fc_img.jpg')
                }
            ],
			swiperList1: [
                {
                    id: 1,
                    src: require('@/assets/about/zz_01.jpg')
                },{
                    id: 2,
                    src: require('@/assets/about/zz_01.jpg')
                },{
                    id: 3,
                    src: require('@/assets/about/zz_01.jpg')
                },{
                    id: 4,
                    src: require('@/assets/about/zz_01.jpg')
                },{
                    id: 5,
                    src: require('@/assets/about/zz_01.jpg')
                },{
                    id: 6,
                    src: require('@/assets/about/zz_01.jpg')
                },{
                    id: 7,
                    src: require('@/assets/about/zz_01.jpg')
                },{
                    id: 8,
                    src: require('@/assets/about/zz_01.jpg')
                },{
                    id: 9,
                    src: require('@/assets/about/zz_01.jpg')
                }
            ],
			swiperList2: [
                {
                    id: 1,
                    src: require('@/assets/about/fc_img.jpg')
                },{
                    id: 2,
                    src: require('@/assets/about/fc_img.jpg')
                },{
                    id: 3,
                    src: require('@/assets/about/fc_img.jpg')
                },{
                    id: 4,
                    src: require('@/assets/about/fc_img.jpg')
                },{
                    id: 5,
                    src: require('@/assets/about/fc_img.jpg')
                },{
                    id: 6,
                    src: require('@/assets/about/fc_img.jpg')
                },{
                    id: 7,
                    src: require('@/assets/about/fc_img.jpg')
                },{
                    id: 8,
                    src: require('@/assets/about/fc_img.jpg')
                },{
                    id: 9,
                    src: require('@/assets/about/fc_img.jpg')
                }
            ],
			cur: 0,
			swiperOptions1: {
                slidesPerView: 3,
				spaceBetween: 30,
				centeredSlides: true,
				loop: true,
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
				autoplay: {
					delay: 3000,
					stopOnLastSlide: false,
					disableOnInteraction: false,
				},
				breakpoints: { 
					320: { 
						slidesPerView: 1,
						spaceBetween: 5
					},
					768: { 
						slidesPerView: 3,
						spaceBetween: 10,
					}
				}
            },
			swiperOptions2: {
                slidesPerView: 4,
				spaceBetween: 50,
				slidesPerGroup: 4,
				loop: true,
				loopFillGroupWithBlank: true,
				speed: 2500,
				// centeredSlides : true,
				// watchSlidesProgress : true,
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				autoplay: {
					delay: 3000,
					stopOnLastSlide: false,
					disableOnInteraction: false,
				},
				
			},
			swiperOptions3: {
                slidesPerView: 4,
				spaceBetween: 30,
				slidesPerGroup: 4,
				loop: true,
				loopFillGroupWithBlank: true,
				speed: 2500,
				// centeredSlides : true,
				// watchSlidesProgress : true,
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				autoplay: {
					delay: 3000,
					stopOnLastSlide: false,
					disableOnInteraction: false,
				},
				
			},
		};
	},
	components: {
		// daohang,
		Swiper,
		SwiperSlide,
		banner2,
	},
	created() {
		this.$nextTick(() => {
			this.toLocal();
		});
	},
	mounted() {
		let _this = this;
		_this.$nextTick(function () {
			window.addEventListener("scroll", _this.handleScroll);
		});
	},
	methods: {
		toLocal() {
			//查找存储的锚点id
			let Id = localStorage.getItem("toId");
			let toElement = document.getElementById(Id);
			//锚点存在跳转
			if (Id) {
				toElement.scrollIntoView();
				localStorage.setItem("toId", "");
			}
		},
	},
};
</script>

<style scoped>
.GroupOverview {
	width: 100vw;
	margin: 0 auto;
}
.about {
	/*height: 600px;*/
	position: relative;
	margin: 50px auto 0;
	width: 1400px;
	padding-bottom: 30px
}
.about-bg .com-title h3 {
    color: #ffffff;
}

.about-bg {
	background: url("../assets/banner/about_02.png") no-repeat center;
	background-size: cover;
	min-height: 900px;
}

.about-top {
	position: relative;
	display: flex;
}

.about-top-l {
	width: 850px;
	color: #ffffff;
}

.about-top-l > span {
	font-size: 32px;
	margin-bottom: 20px;
	display: block;
}

.about-top-l > p {
	font-size: 14px;
	line-height: 40px;
	overflow: hidden;
    /*-webkit-line-clamp: 10; */
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
}

.img-yinying {
	position: absolute;
	top: 58px;
	left: -17px;
	width: 17px;
	height: 408px;
	background: #f8f8f8;
}

.about-top-r {
	position: absolute;
	right: -110px;
}

.about-top-r img {
	width: 550px;
	height: 500px;
}

.about-down {
	position: absolute;
	bottom: 20px;
}

.item {
	top: 236px;
	position: relative;
}

.item2 {
	top: 158px;
	left: 328px;
	position: relative;
}

.item3 {
	top: 79px;
	left: 645px;
	position: relative;
}

.item4 {
	left: 1049px;
	position: relative;
}

.item-1 {
	color: rgba(35, 51, 127, 1);
	font-size: 60px;
}

.item-2 {
	position: absolute;
	color: rgba(35, 51, 127, 1);
	font-size: 16.8px;
}

.item-3 {
	position: absolute;
	left: 88px;
	top: 41px;
	color: rgba(102, 102, 102, 1);
	font-size: 20px;
	width: 100px;
}

.item2-3 {
	position: relative;
	color: rgba(102, 102, 102, 1);
	left: 18px;
	font-size: 20px;
}

.item3-3 {
	position: relative;
	color: rgba(102, 102, 102, 1);
	left: 18px;
	font-size: 20px;
}

.item4-3 {
	position: relative;
	color: rgba(102, 102, 102, 1);
	left: 18px;
	font-size: 20px;
}

.qywh {
	width: 1400px;
	display: block;
	margin: 0 auto;
}

.qywh h1 {
	color: rgba(68, 68, 68, 1);
	font-size: 32px;
	line-height: 134px;
	text-align: center;
}

.qywh-item {
	margin: 30px 200px;

	justify-content: space-between;
	display: flex;
}

.qywh-item1 {
	margin-right: 16px;
	position: relative;
	width: 288px;
	height: 348px;
	background-color: rgba(255, 255, 255, 1);
	box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
	border-radius: 10px;
}

.qywh-item1 span {
	position: absolute;
	left: 91px;
	top: 30px;
	display: inline-block;
	border-radius: 100%;
	width: 90px;
	height: 90px;
	background-color: rgba(52, 145, 229, 1);
}

.qywh-item1 span > img {
	border-radius: 100%;
	height: 100%;
	width: 100%;
}

.qywh-text {
	position: absolute;
	top: 138px;
	left: 91px;
	width: 100px;
	color: rgba(68, 68, 68, 1);
	font-size: 24px;
}

.qywh-text2 {
	position: absolute;
	top: 192px;
	left: 10px;
	text-align: center;
	color: rgba(68, 68, 68, 1);
	font-size: 18px;
	line-height: 28px;
}

.text2-2 {
	width: 91px;
	line-height: 30px;
	position: absolute;
	left: 92px;
}


</style>
